import Grid from "@mui/material/Grid";
import type { ExtratoFinanceiroView } from "../types/extrato-financeiro.types";
import FinanceiroResumoCard from "./FinanceiroResumoCard";

type Props = {
  resumo: ExtratoFinanceiroView["resumo"] | null;
  loading?: boolean;
};

export default function ExtratoFinanceiroResumoCards({ resumo, loading }: Props) {
  const r = resumo;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <FinanceiroResumoCard
          titulo="Total de entradas"
          valor={r?.totalEntradas}
          formato="moeda"
          loading={loading}
          tipo="positivo"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FinanceiroResumoCard
          titulo="Total de saídas"
          valor={r?.totalSaidas}
          formato="moeda"
          loading={loading}
          tipo="alerta"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FinanceiroResumoCard
          titulo="Saldo movimentado"
          valor={r?.saldoMovimentado}
          formato="moeda"
          loading={loading}
          tipo={
            (r?.saldoMovimentado ?? 0) >= 0
              ? "positivo"
              : "negativo"
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FinanceiroResumoCard
          titulo="Taxas"
          valor={r?.totalTaxas}
          formato="moeda"
          loading={loading}
          tipo="alerta"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FinanceiroResumoCard
          titulo="Transferências"
          valor={r?.totalTransferencias}
          formato="moeda"
          loading={loading}
          tipo="neutro"
        />
      </Grid>
    </Grid>
  );
}
